import { render, staticRenderFns } from "./alertcalendar.vue?vue&type=template&id=adbe5324"
import script from "./alertcalendar.vue?vue&type=script&lang=js"
export * from "./alertcalendar.vue?vue&type=script&lang=js"
import style0 from "./alertcalendar.vue?vue&type=style&index=0&id=adbe5324&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports